import React from 'react';

export default function TradingAccounts() {
  // Account data
  const accounts = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      ),
      title: "Secure & Transparent",
      description: "Your funds and data are always protected"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9h18" />
        </svg>
      ),
      title: "Fast Execution ",
      
      description: "Lightning-speed trades with minimal slippage"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
        </svg>
      ),
      title: "Dedicated Support",
      description: "We're here to help, 24/7"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "User-Friendly Interface",
      description: " Designed for both beginners and pros"
    }
  ];

  return (
    <div className='bg-white mb-3'>
    <div className="relative max-w-7xl  mx-auto xl:px-0 px-4 py-8">
    <div className="absolute inset-0 z-0">
      <div
        className="w-full h-full "
        style={{
          backgroundImage: 'url(https://azim.hostlin.com/Fortradex/assets/images/shape/shape-1.png)',
        //   backgroundSize: '30px 30px'
        }}
      ></div>
    </div>
  
    <div className="text-center mb-12 relative z-10">
      <span className="inline-block bg-gradient-to-r from-[#263283] to-[#ed2924] text-white px-3 py-1 rounded-full text-sm font-medium mb-3">
        ACCOUNT
      </span>
      <h2 className="text-4xl font-bold text-gray-900">Why Traders Trust Gold Fox Market</h2>
    </div>
  
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative z-10">
      {accounts.map((account, index) => (
        <div
          key={index}
          className="bg-white rounded-md border border-gray-300 shadow-md p-6 pt-10 relative  transition-transform transform hover:scale-[1.02] hover:shadow-lg duration-300"
        >
          <div className="absolute -top-6 left-6">
            <div className="bg-gradient-to-r from-[#263283] to-[#ed2924] hover:bg-black transition-colors duration-300 w-12 h-12 rounded-lg flex items-center justify-center text-white">
              {account.icon}
            </div>
          </div>
          <h3 className="font-semibold text-gray-800 text-lg mb-2 mt-2">{account.title}</h3>
          <p className="text-gray-600 text-sm text-justify">{account.description}</p>
        </div>
      ))}
    </div>
  </div>
  </div>
  );
}